module.exports = __webpack_public_path__ + "img/peca-xadrez-movida-estrategia.jpg";